import { combineReducers } from "redux";
import Theme from "./Theme";
import Application from "./ApplicationlistReducer";
import Auth from "./Auth";
import Applicationdetail from "./ApplicationdetailReducer";
import userlistreducer from "../../views/app-views/usermanage/redux/reducers/UserListReducer";
import usercreatereducer from "../../views/app-views/usermanage/redux/reducers/UserCreateReducer";
import branchreducer from "../../views/app-views/masterdata/redux/reducers/BranchReducer";
import deporeducer from "../../views/app-views/masterdata/redux/reducers/DepoReducer";
import Complainlistreducer from "./ComplainlistReducer";

import lockedlistReducer from "./LocklistReducers";

const reducers = combineReducers({
  theme: Theme,
  auth: Auth,
  application: Application,
  applicationdetail: Applicationdetail,
  userlist: userlistreducer,
  usercreate: usercreatereducer,
  branch: branchreducer,
  depo: deporeducer,
  complainlist: Complainlistreducer,
  lockedlist: lockedlistReducer,
});

export default reducers;
